import React from 'react';
import { useTranslator } from 'tradera-lang/translate';

const TopDescription = ({ titleKey, descriptions, isError, classes }) => {
    const { t } = useTranslator();

    return (
        <>
            <div className="row">
                <h1
                    className={`col-10 offset-1 text-center mb-0 text-styled heading-madrid ${
                        isError ? 'text-danger' : ''
                    } ${classes || ''}`}>
                    {t(titleKey)}
                </h1>
            </div>
            <div className="row">
                <div className="col-12 col-md-10 offset-md-1 text-md-center">
                    {descriptions.map(descKey => (
                        <div
                            key={descKey}
                            className="d-inline d-md-block ml-md-1">
                            {t(descKey)}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default TopDescription;
